import { VStack } from '@chakra-ui/react'
import { NodeProps } from '@xyflow/react'
import React from 'react'

import { ExtensionInstance } from '@mangovoice/types'

import { FaxDetectNodeData } from '../../converters/shared/reactFlowTypes'
import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { FaxSelector } from '../core'
import { BaseNode, nodePropsAreEqual } from './BaseNode'
import { useFaxDetectNode } from './hooks/useFaxDetectNode'

export interface FaxDetectNodeProps extends NodeProps {
  extensionMap?: Map<number, ExtensionInstance>
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void
  showDeleteButton?: boolean
  // Note: extensionsList is provided via Jotai atoms (extensionsListAtom)
  // Use useSwitchboardDataAtoms hook in the consuming app to set atoms
}

const FaxDetectNodeComponent: React.FC<FaxDetectNodeProps> = ({
  id,
  data,
  extensionMap: _extensionMap, // Reserved for future use (e.g., display formatting)
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const nodeData = data as FaxDetectNodeData & Record<string, unknown>
  const { currentFaxExtensionId, handleFaxExtensionChange, hasData } =
    useFaxDetectNode(id, nodeData)
  const t = useSwitchboardT()

  return (
    <BaseNode
      label={text(t, 'switchboard.nodeLabels.fax_detect', 'FAX DETECT')}
      showPlaceholder={!hasData}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
    >
      <VStack align="stretch" gap={2}>
        <FaxSelector
          value={currentFaxExtensionId}
          onChange={handleFaxExtensionChange}
          t={t}
        />
      </VStack>
    </BaseNode>
  )
}

export const FaxDetectNode = React.memo(
  FaxDetectNodeComponent,
  nodePropsAreEqual,
)
